module.exports = __webpack_public_path__ + "static/media/1.8cd809ad.jpg";